<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:21:26
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-16 10:18:13
-->
<template>
  <div>
    <div class="top">
      <div class="top-btn">
        <el-button
          v-if="codeData.indexOf('201') != -1"
          @click="add"
          type="primary"
          >添加问题</el-button
        >
      </div>
      <div class="search">
        <a-input
          v-model="seachValue"
          placeholder="推荐问题内容"
          style="width: 173px"
        />
        <el-button style="margin-left: 12px" type="primary" @click="search"
          >查询</el-button
        >
      </div>
    </div>
    <coententTable
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :pagination="pagination"
      :dataSource="dataSource"
      :customSlot="customSlot"
      :loading="loading"
      :y="height"
      @handleSizeChange="handleSizeChange"
    >
      <template v-slot:collectStatus="scopeVal">
        <div
          :class="[
            scopeVal.scope.collectStatus == 1
              ? 'collectStatus1'
              : scopeVal.scope.collectStatus == 2
              ? 'collectStatus2'
              : '',
          ]"
        >
          {{
            scopeVal.scope.collectStatus == 0
              ? "未开始"
              : scopeVal.scope.collectStatus == 1
              ? "进行中"
              : "已结束"
          }}
        </div>
      </template>
      <template v-slot:interviewStartTime="scopeVal">
        <div>
          {{ scopeVal.scope.interviewStartTime }} 至
          {{ scopeVal.scope.interviewEndTime }}
        </div>
      </template>
      <template v-slot:sort="scopeVal">
        <div class="sort">
          <div class="sort-box">
            <img
            v-if="codeData.indexOf('205') != -1"
              @click="sort(scopeVal.scope, true)"
              class="img"
              src="@/assets/images/up.jpg"
            />
          </div>
          <input disabled v-model="scopeVal.scope.sort" class="sort-style" />
          <div class="sort-box-two">
            <img
            v-if="codeData.indexOf('205') != -1"
              @click="sort(scopeVal.scope, false)"
              class="img"
              src="@/assets/images/down.png"
            />
          </div>
        </div>
      </template>
      <template v-slot:displayStatus="scopeVal">
        <a-switch
         v-if="codeData.indexOf('204') != -1"
          :v-model="scopeVal.scope.whetherEnable"
          :checked="scopeVal.scope.whetherEnable ? true : false"
          @change="(checked) => changeDisplayStatus(checked, scopeVal.scope.id)"
        />
      </template>
      <template v-slot:operation="scopeVal">
        <a class="btnThree"  v-if="codeData.indexOf('206') != -1" @click="open(scopeVal.scope)"
          >删除</a
        >
      </template>
    </coententTable>
    <el-dialog
      title="确认删除常见问题?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      custom-class="tips-box"
      :before-close="handleClose"
      top="17%"
    >
      <span>请确认是否继续删除操作。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTwo = false">取消</el-button>
        <el-button :loading="deleteShow" type="danger" @click="deleteOne()">确认删除</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择常见问题"
      :visible.sync="answersShow"
      width="820px"
      class="column-box"
      top="12%"
    >
      <div class="searchTwo">
        <el-select
          style="margin-right: 12px"
          size="small"
          v-model="isQuestionClassificationId"
          placeholder="请选择"
        >
         <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.classificationName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <a-input
          v-model="questionDescription"
          placeholder="按标准问题搜索"
          style="width: 173px"
        />
        <a-button style="margin-left: 12px;background:#176de6" type="primary" @click="searchTwo"
          >查询</a-button
        >
      </div>
      <a-spin :spinning="loadingAddQier">
            <a-table
              :columns="columnsTwo"
              :data-source="dataSourceTwo"
              :row-selection="rowSelection"
              :pagination="false"
              :scroll="{y: 400 }"
              rowKey="id"
              :locale="locale"
              class="change-table"
            >
        </a-table>
      <div class="footer-page">
         <a-pagination  :pageSize="size"  :current="current" :total="total" @change="onChange" />
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="answersShow = false">取 消</el-button>
          <el-button :loading="submintShow"   v-if="codeData.indexOf('203') != -1" size="small" type="primary" @click="tihuan">保存</el-button>
        </span>
      </div>
       </a-spin>
      
    </el-dialog>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import {
  findListPage,
  updateDisplayStatus,
  collectDelete,
  updateHotSort,
  findAnswerListPage,
  findList,
  saveQuestionCommon
} from "./chan";
export default {
  components: {
    coententTable,
  },
  data() {
    return {
      seachValue: "",
      wenti: "",
      isQuestionClassificationId:'',
      questionDescription: "",
      deleteShow:false,
      submintShow:false,
      loadingAddQier:false,
      columns: [
        {
          title: "常见问题",
          dataIndex: "questionDescription",
          ellipsis: true,
          customCell: column => {
                        return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    },
                    customHeaderCell: column => {
                    return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    }
        },
        {
          title: "排序",
          dataIndex: "interviewStartTime",
          scopedSlots: { customRender: "sort" },
          ellipsis: true,
          width: 120,
        },
        {
          title: "是否启用",
          dataIndex: "whetherEnable",
          scopedSlots: { customRender: "displayStatus" },
          ellipsis: true,
          width: 120,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 100,
        },
      ],
      columnsTwo: [
        {
          title: "标准问题",
           ellipsis: true,
          dataIndex: "questionDescription",
        },
        {
          title: "所属分类",
           ellipsis: true,
          dataIndex: "classificationName",
        },
      ],
      dataSourceTwo: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
      },
      dataSource: [],
      customSlot: [
        {
          id: 1,
          name: "displayStatus",
          customRender: "displayStatus",
        },
        {
          id: 2,
          name: "sort",
          customRender: "sort",
        },
      ],
      loading: false,
      height: 0,
      collectTheme: "", //
      collectUnit: "",
      dialogVisibleTwo: false,
      item: {},
      seeData: [],
      answersShow: false,
      ruleForm: {},
      options: [],
      current:1,
      total:0,
      size:10,
      rowKeys:[],
      codeData:[],
       locale:{emptyText:<el-empty description="暂无数据"></el-empty>},
    };
  },
  mounted() {
    this.getListPage();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.rowKeys,
        fixed:true,
        columnWidth:'48px',
        onChange: (selectedRowKeys, selectedRows) => {
           this.rowKeys = selectedRowKeys;
        },
      };
    },
  },
  methods: {
    getQuestionList(){
      findList({
        siteId:sessionStorage.getItem('siteId')
      }).then((res)=>{
          if(res.code == 0){
              this.options = res.data;
          }
      })
    },
    onChange(page){
        this.current = page;
        this.getAnswerPage();
    },
    searchTwo(){
      this.current = 1;
      this.total = 0;
      this.getAnswerPage();
    },
    getAnswerPage(){
        this.loadingAddQier = true;
      findAnswerListPage({
        current:this.current,
        isQuestionClassificationId:this.isQuestionClassificationId,
        questionDescription:this.questionDescription,
        size:this.size,
        siteId:sessionStorage.getItem('siteId')
      }).then((res)=>{
          if(res.code == 0){
              this.dataSourceTwo = res.data.records;
              this.total = res.data.total;
          }
            this.loadingAddQier = false;
      })
    },
    tihuan() {
        this.submintShow = true;
        saveQuestionCommon({
          siteId:sessionStorage.getItem('siteId'),
          isQuestionAnswerIds:this.rowKeys,
        }).then((res)=>{
            if(res.code == 0){
                this.getListPage();
                this.answersShow = false;
                this.submintShow = false;
            }
        })
    },
    add() {
      this.answersShow = true;
      this.rowKeys = [];
      this.dataSourceTwo = [];
      this.total = 0;
      this.current  = 1;
      this.getQuestionList();
      this.getAnswerPage();
    },
    open(item) {
      this.item = JSON.parse(JSON.stringify(item));
      this.dialogVisibleTwo = true;
    },
    handleClose() {
      this.dialogVisibleTwo = false;
    },
    search() {
      this.pagination.current = 1;
      this.getListPage()
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getListPage();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getListPage();
    },
    getListPage() {
      const _this = this;
      _this.loading = true;
      let reqData = {
        current: _this.pagination.current,
        siteId: sessionStorage.getItem("siteId"),
        size: _this.pagination.pageSize,
        questionDescription: _this.seachValue,
      };
      findListPage(reqData).then((res) => {
        if (res.code == 0) {
          _this.dataSource = res.data.records;
          _this.pagination.current = res.data.current;
          _this.pagination.total = res.data.total;
          if(_this.pagination.total > 0){
            this.height = document.documentElement.clientHeight - 500;
            window.onresize = () => {
              return (() => {
                this.height = document.documentElement.clientHeight - 500;
              })();
            };
          }
          _this.pagination.pageSize = res.data.size;
          _this.loading = false;
        }
      });
    },
    changeDisplayStatus(displayStatus, id) {
      updateDisplayStatus({
        whetherEnable: displayStatus ? 1 : 0,
        id: id,
      }).then((res) => {
        if (res.code == 0) {
          this.getListPage();
        }
      });
    },
    deleteOne() {
      this.deleteShow = true;
      collectDelete({
        id: this.item.id,
        siteId: sessionStorage.getItem("siteId"),
      }).then((res) => {
        if (res.code == 0) {
          this.dialogVisibleTwo = false;
          this.deleteShow = false;
          this.getListPage();
        }
      });
    },
    editAdmin(item) {
      this.ruleForm = item;
      this.answersShow = true;
    },
    sort(item, type) {
      updateHotSort({
        id: item.id,
        type,
      }).then((res) => {
        if (res.code == 0) {
          this.getListPage();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #E4E7ED 1px;
  display: flex;
  justify-content: space-between;
  .search {
            display: flex;
            /deep/ .ant-select-selection {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .ant-input {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .el-select .el-input__inner {
                background-color: rgba(245, 247, 250, 1);
            }
            /deep/ input::-webkit-input-placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__rendered {
                line-height: 39px;
            }
            /deep/ input::-webkit-input-placeholder {
            color: #415058;
            }
            /deep/ .ant-select-selection__placeholder {
                color: #415058;
            }
        }
  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
.collectStatus1 {
  color: #1890ff;
}
.collectStatus2 {
  color: #909399;
}
/deep/.ant-switch-checked {
  background-color: #39d362;
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 90px;
  border-radius: 5px;
}
.sort-box {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
}
.sort-box-two {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
}
.sort-style {
  width: 30px;
  border: none;
  outline: none;
  text-align: center;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 24px;
}
.el-button--primary {
  background: #176de6;
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.searchTwo {
  display: flex;
}
.change-table{
  margin-top: 21px;
}
.footer-page{
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.column-box{
 
 /deep/ .el-dialog__body{
   padding-top: 10px;
 }
/deep/ .ant-table-column-title {
  color: #000;
  font-size: 14px;
  font-weight: 600;
}
.btn {
  margin-right: 14px;
}

/deep/ .ant-table-tbody > tr > td{
    padding: 9.5px 16px;
    color: #303133;
}
/deep/ .ant-table-thead > tr > th{
   padding: 12.5px 16px;
}
/deep/ .ant-table-fixed-left{
  border-right: 1px solid rgba(228, 231, 237, 1);
}
/deep/ .ant-table-fixed-right{
    border-left: 1px solid rgba(228, 231, 237, 1);
    
}
/deep/ .ant-table-fixed-right .ant-table-tbody > tr > td{
   padding: 9.5px 24px;
}
/deep/ .ant-table-fixed-right .ant-table-thead > tr:first-child > th:last-child{
  padding: 12.5px 24px;
  
}
/deep/ .ant-table-thead > tr > th{
    background-color: rgba(245, 247, 250, 1);
}
/deep/ .ant-table-thead > tr{
   background-color: rgba(245, 247, 250, 1);
}
/deep/ .ant-table-hide-scrollbar{
  background-color: rgba(245, 247, 250, 1);
  
}
/deep/ .ant-table-column-title{
    color: #606266;
}
/deep/ .ant-table{
  border: solid 1px #E4E7ED;
}
/deep/ .ant-table-fixed-left table,.ant-table-fixed-right table{
    width: min-content;
    }
    /deep/ .ant-table-row-cell-ellipsis {
      max-width: 1px !important;
      overflow: hidden !important;
      white-space: nowrap !important;
      -o-text-overflow: ellipsis !important;
      text-overflow: ellipsis !important;
  }

  /deep/ .el-empty__description p{
    color: rgba(16, 16, 16, 1);
    font-size: 16px;
    text-align: left;
    font-family: Roboto-regular;
  }
  /deep/ .el-empty{
    padding: 11px 0px 15px 0px;
  }
  /deep/ .el-empty__description{
    margin-top: 10px;
  }
  /deep/ .ant-table-placeholder{
    border-bottom: none;
  }

   /deep/ tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background:#fafafa !important;
  }
  /deep/ tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td{
    background:#fafafa !important;
  }
  /deep/ .ant-table {
  border: solid 1px #f1f1f1;
  border-bottom: none;
  border-radius: 5px;
  color: rgba(255, 255, 255, 1);
}
}
</style>